<div class="header">
  <div class="govuk-width-container d-flex">
      <gb-ui-header
          [imageDetail]="imageDetail"
          [showSearch]="true"
          [displayLinksBelow]="true"
          (searchTerm)="search($event)"
        >
      </gb-ui-header>
  </div>
</div>
